"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = exports.FeatureUnavailableError = exports.ConflictError = exports.UnauthorizedError = exports.TooManyRequests = exports.NotFoundError = exports.InternalServerError = exports.ForbiddenError = exports.BadRequestError = exports.ApiError = exports.BaseError = void 0;
/**
 * BaseError is the base class for all internal errors.
 * It must not be exposed directly to any client or api consumer.
 */
class BaseError extends Error {
    constructor(message, details) {
        super(message);
        this.type = this.constructor.name;
        this.name = this.constructor.name;
        this.details = details;
    }
}
exports.BaseError = BaseError;
/**
 * ApiError is the base class for all errors that can be exposed to consumers.
 */
class ApiError extends BaseError {
}
exports.ApiError = ApiError;
class BadRequestError extends ApiError {
}
exports.BadRequestError = BadRequestError;
class ForbiddenError extends ApiError {
}
exports.ForbiddenError = ForbiddenError;
class InternalServerError extends ApiError {
}
exports.InternalServerError = InternalServerError;
class NotFoundError extends ApiError {
}
exports.NotFoundError = NotFoundError;
class TooManyRequests extends ApiError {
}
exports.TooManyRequests = TooManyRequests;
class UnauthorizedError extends ApiError {
}
exports.UnauthorizedError = UnauthorizedError;
class ConflictError extends ApiError {
}
exports.ConflictError = ConflictError;
class FeatureUnavailableError extends TooManyRequests {
    constructor(message = 'Feature unavailable', details) {
        super(message, details);
        this.name = this.constructor.name;
    }
}
exports.FeatureUnavailableError = FeatureUnavailableError;
/**
 * ValidationError is a specific type of BadRequestError.
 * It can be built from a Zod validation error.
 */
class ValidationError extends BadRequestError {
    static buildFromZodError(error) {
        return new ValidationError(error.message, { issues: error.issues });
    }
}
exports.ValidationError = ValidationError;
//# sourceMappingURL=error.js.map